var render, staticRenderFns
import script from "./Magnifiable.vue?vue&type=script&lang=ts&"
export * from "./Magnifiable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e18b7f0",
  null
  
)

export default component.exports